import {Col, Image, Row} from "react-bootstrap";
import heroImage from "../../../assets/2517872.png";
import React from "react";
import {mailLink, portfolioData} from "../../../data/data";
import './Intro.css';

const Intro = () => <Row id='intro' className={'hero-section py-5 px-4 mt-2'}>
    <Col md={7} sm={12} xs={12}>
        <div className={'hello'}>Hello,</div>
        <div className={'intro'}>
            <div dangerouslySetInnerHTML={{__html: portfolioData.promoContent()}}/>
            <br/><br/>
            <small>
                Got an interesting project? Send me a message at&nbsp;
                <span
                    style={{
                        paddingBottom: '0.3em'
                    }}>
                    <a href={mailLink} style={{color: '#4dc0b5'}}> {portfolioData.email} </a>
                </span>
            </small>
        </div>
    </Col>
    <Col md={5} sm={12} xs={12} className={'text-center px-5 '}>
        <Image src={heroImage} fluid/>
    </Col>
</Row>;

export default Intro;